import React, { useState, useEffect } from "react";
import { InputNameDialog } from "components";
import { useSiteFurtherInfo, useUpdateSiteFurtherInfo } from "hooks";

interface ViewMoreInfoModalProps {
    isOpen: boolean;
    onClose: () => void;
    siteId: number;
}

export const ViewMoreInfoModal = ({ isOpen, onClose, siteId }: ViewMoreInfoModalProps) => {
    const [furtherInfo, setFurtherInfo] = useState("");
    const { data: existingInfo, refetch, isFetching } = useSiteFurtherInfo(siteId, isOpen);
    const updateMutation = useUpdateSiteFurtherInfo();

    useEffect(() => {
        setFurtherInfo("");
    }, [siteId]);

    useEffect(() => {
        if (existingInfo) {
            setFurtherInfo(existingInfo);
        } else {
            setFurtherInfo("");
        }
    }, [existingInfo]);

    const handleSubmit = async (newFurtherInfo: string) => {
        try {
            await updateMutation.mutateAsync({
                siteId,
                furtherInfo: newFurtherInfo
            });
            refetch();
        } catch (error) {
            // Error handling is done in the mutation hook
        }
    };

    const handleClose = () => {
        setFurtherInfo(existingInfo || "");
        onClose();
    };

    return (
        <InputNameDialog
            isOpen={isOpen}
            onClose={handleClose}
            onSubmit={handleSubmit}
            mainTitle="Further Information"
            placeholder="Provide additional information or guidance related to this site or its Scorecard."
            submitButtonText="Save"
            cancelButtonText="Cancel"
            isLoading={updateMutation.isLoading}
            defaultValue={furtherInfo}
            loadingDefaultValue={isFetching}
            longTextField
            enableEdit={furtherInfo !== ""}
            readOnly={furtherInfo !== ""}
        />
    );
};

